import { useContext } from "react";

import { AdminContext } from "../contexts/AdminContext";
// import { AuthContext } from "../contexts/FirebaseAuthContext";
// import { AuthContext } from "../contexts/Auth0Context";
// import { AuthContext } from "../contexts/CognitoContext";

const useAdmin = () => {
  const context = useContext(AdminContext);

  if (!context) throw new Error("AdminContext must be placed within AdminProvider");

  return context;
};

export default useAdmin;
